import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
export const useSupportRequestMessagesStore = defineStore('supportRequestMessages', {
  id: 'supportRequestMessages',
  state: () => ({
    items: [],
    supportRequestScreenshotBlob: null,
    api: '/api/v1/support-request-messages'
  }),
  getters: {
    getItemsBySupportRequestId: (state) => (supportRequestId) => {
      return state.items.filter(item => item.support_request_id === supportRequestId)
    },
    ...getters
  },
  actions: {
    supportRequestScreenshotBlobSet (supportRequestScreenshotBlob) {
      this.supportRequestScreenshotBlob = supportRequestScreenshotBlob
    },
    ...actions,
  }
})
